import ElementConfig from '../classes/definitions/formItem/ElementConfig';
import FormItem from '../classes/definitions/formItem/FormItem';
var searchSchema = {
    option_type: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            options: [
                { label: 'Term (1:1  (точен израз)', value: 'exact_match' },
                { label: 'Any match (съвпадение по някоя от думите)', value: 'any_match' },
                { label: 'All match (съвпадение по всички от думите)', value: 'all_match' }
            ]
        }),
        elementType: 'dropdown',
        label: 'Тип',
        value: null,
        validation: {
            required: false,
        },
        valid: true,
        touched: false,
        errorMsg: 'Моля, въвдете валиден Тип',
    }),
    search_value: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'text',
        }),
        elementType: 'input',
        label: 'Съчетание',
        value: '',
        validation: {
            required: true,
        },
        valid: false,
        touched: false,
        errorMsg: 'Моля, въвдете валидно съчетание',
    }),
    autocompleteInput1: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            multiple: false,
        }),
        elementType: 'autocomplete',
        value: [],
        validation: {
            required: false,
        },
        valid: true,
        touched: false,
        errorMsg: 'Моля, въвдете валидна категория',
    }),
    autocompleteInput2: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            multiple: false,
        }),
        elementType: 'autocomplete',
        value: [],
        validation: {
            required: false,
        },
        valid: true,
        touched: false,
        errorMsg: 'Моля, въвдете валидна категория',
    }),
    autocompleteInput3: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            multiple: false,
        }),
        elementType: 'autocomplete',
        value: [],
        validation: {
            required: false,
        },
        valid: true,
        touched: false,
        errorMsg: 'Моля, въвдете валидна категория',
    }),
    autocompleteInput4: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            multiple: false,
        }),
        elementType: 'autocomplete',
        value: [],
        validation: {
            required: false,
        },
        valid: true,
        touched: false,
        errorMsg: 'Моля, въвдете валидна категория',
    }),
    autocompleteInput5: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            multiple: false,
        }),
        elementType: 'autocomplete',
        value: [],
        validation: {
            required: false,
        },
        valid: true,
        touched: false,
        errorMsg: 'Моля, въвдете валидна категория',
    }),
};
export default searchSchema;



//////////////////
// WEBPACK FOOTER
// ./src/schemas/searchSchema.ts
// module id = 455
// module chunks = 0